module.exports = __webpack_public_path__ + "static/favicon-dbada5a133041ea240845c1b31e074a2.ico";